import { FC } from "react";
import { List } from "antd";
import { IDisciplineViewerList } from "Data/interfaces/FederatedViewer/IDisciplineViewerList";
import { Icon, IconName } from "Components/UI";
import HighlighterWords from "Components/UI/HighlightWords";

interface IMoveFilesModalListDisciplines {
  filteredDisciplines: any;
  searchDisciplineFile: string;
  onDisciplineFolder: (value: IDisciplineViewerList | null) => void;
  onOpenFolder: (
    folderId: string, 
    ConstructionSiteDisciplinesId?: number, 
    folderName?: string,
    isObsoleteFolder?: boolean,
  ) => void;
  onIconLeft: (name: string) => IconName;
}

const MoveFilesModalListDisciplines: FC<IMoveFilesModalListDisciplines> = ({
  filteredDisciplines,
  searchDisciplineFile,
  onDisciplineFolder,
  onOpenFolder,
  onIconLeft,
}) => {
  return (
    <List
      itemLayout="horizontal"
      dataSource={filteredDisciplines}
      split={false}
      renderItem={(item: any) => (
        <List.Item
          className="rowDisciplinesList"
          onClick={() => {
            onDisciplineFolder(item);
            onOpenFolder(item.DisciplineApiFolderId, item.ConstructionSiteDisciplinesId);
          }}
        >
          <div className="leftRowDisciplinesList">
            <Icon
              icon={onIconLeft(item.CustomName || item.Discipline.Name)}
              customSize={16}
              className="iconLeftRowDisciplinesList"
            />
            <HighlighterWords
              text={item.CustomName || item.Discipline.Name}
              wordSearched={searchDisciplineFile}
              className="disciplineListText"
            />
          </div>
          <Icon
            icon="retroceder"
            customSize={8}
            className="iconRetroceder"
          />
        </List.Item>
      )}
    />
  )
}

export default MoveFilesModalListDisciplines;
